<template>
  <div v-if="url">
    <a class="cell-link" :href="url">
      <slot />
    </a>
    <a class="tw:inline" :href="url">
      <slot name="accessoryIcon" />
    </a>
  </div>
  <div v-else>
    <slot />
    <div v-if="hasUrl" class="tw:inline tw:hover:invisible! tw:invisible!">
      <slot name="accessoryIcon" />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    url: String,
    hasUrl: Boolean,
  },
};
</script>

<style scoped>
.cell-link {
  color: var(--v-text-base);
}
</style>
